exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".notfound {\n  text-align: center;\n  padding-top: 3.28rem;\n}\n.notfound img {\n  width: 2rem;\n  height: 2rem;\n}\n.notfound p {\n  margin-top: 0.2rem;\n  text-align: center;\n  font-size: 0.24rem;\n  color: #CCC;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader??ref--2-1!../node_modules/postcss-loader!../node_modules/less-loader/dist/cjs.js!./component/NotFound/index.less
// module id = ../node_modules/css-loader/index.js??ref--2-1!../node_modules/postcss-loader/index.js!../node_modules/less-loader/dist/cjs.js!./component/NotFound/index.less
// module chunks = 0